import gql from 'graphql-tag';

export default gql`
    query {
        getToken {
            secret
            otpauth
            token
        }
    }
`;